import {
  gql, useQuery, useMutation, MutationFunctionOptions, useLazyQuery,
} from "@apollo/client";
import { apolloClientUnauthenticated } from "../../apollo";
import { clearCookies } from "../../../utils/clearCookies";

export const GET_PREVIOUS_VALUES_QUERY = gql`query($contactId: ID!) {
  home(contactId: $contactId) {
    currentMonthlyRepayment
    balance
    propertyValue
    productEndDate
    currentTerm
  }
  applicationsForUser(userId: "")
}`;

export const GET_APPLICATION_QUERY = gql`
  query ($applicationId: ID!) {
    applicationDetails(applicationId: $applicationId) {
      status
    }
  }`;

export const usePreviousValues = (contactId: string) => useQuery<{home: {
  currentMonthlyRepayment: number;
  balance: number;
  propertyValue: number;
  productEndDate: Date;
  currentTerm: number;
};
  applicationsForUser: [string];
}>(GET_PREVIOUS_VALUES_QUERY, { variables: { contactId }, skip: !contactId });

export const usePreviousStatus = () => useLazyQuery<{applicationDetails: {
  status?: string;
}}>(GET_APPLICATION_QUERY);

export const getRepayments = async (propertyValue: number, loanAmount: number, currentTerm: number) => apolloClientUnauthenticated.query<{
    getBestMonthlyRepayments: {
      monthlyRepayment: number;
      initialPeriodRate: number;
    }
  }>({
    query: gql`query($loanAmount: Float!, $propertyValue: Float!, $currentTerm: Int!) {
      getBestMonthlyRepayments(
        loanAmount: $loanAmount,
        initialTerm: TWO_YEAR,
        productType: FIXED,
        term: $currentTerm,
        propertyValue: $propertyValue,
        purpose: REMORTGAGE,
        intent: RESIDENTIAL,
        limit: 100,
        sortBy: TRUE_COST,
      ) {
        monthlyRepayment,
        initialPeriodRate
      }  
    }`,
    variables: {
      loanAmount, propertyValue, currentTerm,
    },
  });

export const CREATE_NEW_REMORTGAGE_MUTATION = gql`mutation (
  $userId: ID!
  $customer: CreateMortgageApplicationCustomer
  $applicationId: ID
  $dualApplicantId: ID
) {
  createMortgageApplication(
    createMortgageApplicationParams: {
      userId: $userId
      customer: $customer
      applicationId: $applicationId
      dualApplicantId: $dualApplicantId
    }
  ) {
    application {
      id
    }
  }
}`;
export const useCreateNewRemortgage = () => {
  const [acceptOffer] = useMutation(CREATE_NEW_REMORTGAGE_MUTATION, {
    variables: {
      customer: {
        purchasingPurpose: "REMORTGAGE",
        mainApplicant: {
          consent: {
            privacyPolicyAndTerms: {
              consentGiven: true,
              lastUpdated: `${new Date().getTime()}`,
            },
          },
        },
        intent: "REMORTGAGE",
      },
    },
  });

  return async (options: MutationFunctionOptions) => {
    clearCookies();
    await acceptOffer(options);
  };
};

export const SAVE_VALUES_MUTATION = gql`mutation($editHomeParams: EditHome!) {
  editHome(editHomeParams: $editHomeParams) {
    id
  }
}`;

export const useSaveHomeApiValues = () => useMutation(SAVE_VALUES_MUTATION);
